// @flow

export const balanceTypes = Object.freeze({
  All: 'all',
  Cafeteria: 'cafeteria',
  Camp: 'camp',
});

export type BalanceType = $Values<typeof balanceTypes>
